// Copyright (c) 2023 Visual Intelligence LP. All rights reserved.
//

export enum EquipmentStatus {
    inactive = 0,
    active = 1
}

export const EQUIPMENT_STATUS_LABEL = {
    [EquipmentStatus.inactive]: 'Inactive',
    [EquipmentStatus.active]: 'Active'
}
